import React, { useEffect, useState } from 'react';
import CapacityAnalysisPage from './CapacityAnalysisPage';
import CapacityOverviewCascade from './CapacityOverviewCascade';
import { getCapacityOverview } from '../../api/capacityOverview';

/* Vue d'ensemble de la capacité — la cascade du temps total à la capacité
   pratique, groupe par groupe.

   Extraite de `TimePilotHub` le 2026-08-30, quand elle est passée en tête de
   « Saisie des temps » : elle porte sa propre requête, celle que le hub faisait
   pour elle. `CapacityAnalysisPage` reçoit la cascade en prop plutôt que d'aller
   la chercher — elle sert ailleurs avec d'autres périmètres. */
export default function CapacityOverviewTab({ activeTenant, addToast, year }) {
  const tenantId = activeTenant?.id;
  const [ov, setOv] = useState(null);
  useEffect(() => {
    if (!tenantId) { setOv(null); return undefined; }
    let alive = true;
    getCapacityOverview(tenantId, year)
      .then((r) => { if (alive) setOv((r && r.data) || r || null); })
      .catch(() => { if (alive) setOv(null); });
    return () => { alive = false; };
  }, [tenantId, year]);

  /* La cascade en tuiles est retournée dans « Capacité pratique (TR) » le
     2026-08-30, en tête : elle explique le chiffre qu'on y saisit. */
  return (
    <CapacityAnalysisPage
      embedded hideMetricsTables activeTenant={activeTenant} addToast={addToast} year={year} overview={ov}
      afterSynth={<CapacityOverviewCascade tenantId={tenantId} year={year} addToast={addToast} />}
    />
  );
}
